/** @jsx isolateComponent */

import { css } from '@emotion/react';
import { ZapCard, ZapCardProps } from '../ZapCard';
import { labelStyles, isolateComponent } from '@zapier/style-encapsulation';
import { Colors, ColorValue } from '@zapier/design-system';

type Items = Omit<ZapCardProps, 'color'> & {
  color?: ColorValue;
  key: string;
};

export type Props = {
  /**
   * defines the contents of each ZapCard
   */
  items: Items[];
  layout?: 'auto' | 'card' | 'mega';
};

const breakpoints = {
  tablet: 768,
  desktop: 1230,
};

const Styles = labelStyles('ZapCardSection', {
  root: css`
    padding: 20px;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      padding: 20px 30px;
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
      padding: 40px;
    }
  `,

  container: (layout: Props['layout']) => css`
    display: grid;
    gap: 30px;
    grid-template-columns: ${layout === 'auto'
      ? '1fr'
      : 'repeat(auto-fit, minmax(235px, 1fr))'};
    margin: 0 auto;
    max-width: 1170px;
  `,
});

export const ZapCardSection = ({ items, layout = 'card' }: Props) => {
  if (items.length > 3) {
    console.error('Max 3 items are allowed in ZapCardSection component');
  }
  return (
    <div css={Styles.root}>
      <div css={Styles.container(layout)}>
        {items
          ?.slice(0, 3)
          ?.map(({ color = Colors.neutral100, href, ...rest }) => (
            <ZapCard {...rest} color={color} href={href} layout={layout} />
          ))}
      </div>
    </div>
  );
};
